import styled from "styled-components";

export const Linea = styled.div`
    height: 1px;
    width: 90%;
    background-color: ${props => props.color}
`